import React from 'react';

const ServiceCard = ({ project }) => {
  return (
    <div className="project-card">
      {project.image && (
        <div className="project-image-container">
          <img 
            src={project.image} 
            alt={project.title}
            className="project-card-image"
          />
        </div>
      )}
      <div className="project-header">
        <div className="project-icon">{project.icon}</div>
        <span className="project-category">{project.category}</span>
      </div>
      <h3>{project.title}</h3>
      <p className="project-description">{project.description}</p>
      <div className="project-stats">
        {Object.entries(project.stats).map(([key, value]) => (
          <div key={`${project.title}-${key}`} className="stat">
            <span className="stat-label">{key}</span>
            <span className="stat-value">{value}</span>
          </div>
        ))}
      </div>
      <div className="project-status">
        <span className={`status-badge ${project.status === 'Operational' ? 'operational' : 'planning'}`}>
          {project.status}
        </span>
      </div>
    </div>
  );
};

export default ServiceCard;
